import { render } from "./chat.vue?vue&type=template&id=89c9ffd4&scoped=true"
import script from "./chat.vue?vue&type=script&lang=ts"
export * from "./chat.vue?vue&type=script&lang=ts"

import "./chat.vue?vue&type=style&index=0&id=89c9ffd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-89c9ffd4"

export default script